import React from 'react';
import { useTranslation } from 'react-i18next';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';

import s from './FakeCommentBoxSisuPlaceholder.scss';

/**
 * Non-interactive placeholder that matches the comment editor chrome for anonymous users when SISU popover is enabled.
 */
const FakeCommentBoxSisuPlaceholder: React.FC = () => {
  const { t } = useTranslation();

  return (
    <PlainButtonOrLink type="button" fillContainerWidth className={s['root']}>
      {t('commentbox.editor.placeholder')}
    </PlainButtonOrLink>
  );
};
FakeCommentBoxSisuPlaceholder.displayName = 'FakeCommentBoxSisuPlaceholder';

export default FakeCommentBoxSisuPlaceholder;
